import o from "./highrise306.mjs";
/* empty css             */
import t from "./highrise181.mjs";
const m = /* @__PURE__ */ t(o, [["__scopeId", "data-v-0e0d4fd3"]]);
export {
  m as default
};
